import { Building2, Zap, Droplets, AirVent, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import Reveal from "./Reveal";
import { scrollToId } from "./Navbar";

const ICONS = {
  reformas: Building2,
  electricidad: Zap,
  fontaneria: Droplets,
  climatizacion: AirVent,
};

const SPANS = [
  "lg:col-span-4",
  "lg:col-span-2",
  "lg:col-span-3",
  "lg:col-span-3",
];

const Services = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="bg-grid-light relative bg-bone py-28 lg:py-40"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <Reveal>
          <div className="mb-16 flex flex-col gap-6 lg:mb-20 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p
                data-testid="services-eyebrow"
                className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta"
              >
                {t.services.eyebrow}
              </p>
              <h2
                data-testid="services-heading"
                className="mt-5 max-w-xl font-display text-3xl font-medium leading-tight tracking-tight text-charcoal sm:text-4xl"
              >
                {t.services.heading}
              </h2>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-stone-500">
              {t.services.sub}
            </p>
          </div>
        </Reveal>

        <div
          data-testid="services-grid"
          className="grid gap-px border border-black/10 bg-black/10 md:grid-cols-2 lg:grid-cols-6"
        >
          {t.services.items.map((s, i) => {
            const Icon = ICONS[s.id] || Building2;
            return (
              <Reveal key={`${lang}-${s.id}`} delay={i * 0.08} className={SPANS[i]}>
                <article
                  data-testid={`service-card-${s.id}`}
                  onClick={() => scrollToId("#presupuesto")}
                  className="group relative flex h-full cursor-pointer flex-col justify-between bg-bone p-8 transition-colors duration-500 hover:bg-charcoal lg:p-10"
                >
                  <div className="flex items-start justify-between">
                    <Icon
                      size={30}
                      strokeWidth={1.4}
                      className="text-terracotta transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110"
                    />
                    <span className="font-mono text-[11px] tracking-[0.25em] text-stone-400 transition-colors duration-500 group-hover:text-stone-500">
                      S.0{i + 1}
                    </span>
                  </div>
                  <div className="mt-14">
                    <h3 className="font-display text-2xl font-medium leading-snug text-charcoal transition-colors duration-500 group-hover:text-bone">
                      {s.title}
                    </h3>
                    <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-terracotta">
                      {s.tags}
                    </p>
                    <p className="mt-4 text-sm leading-relaxed text-stone-500 transition-colors duration-500 group-hover:text-stone-400">
                      {s.desc}
                    </p>
                    <span className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-charcoal opacity-0 transition-all duration-500 group-hover:opacity-100 group-hover:text-terracotta">
                      {t.services.cta}
                      <ArrowUpRight size={13} />
                    </span>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
